import { Dispatch, SetStateAction, forwardRef } from 'react';
import { css } from '@emotion/react';
import { Pagination } from '@frontend/design-system';
import { Text } from '@frontend/design-system';
import { DEVICE_LAYOUT_WIDTH } from '../constants';

export const LineKeyPagination = forwardRef<
  HTMLDivElement,
  {
    pageNum: number;
    totalPages: number | undefined;
    helperText?: string;
    setPageNum: Dispatch<SetStateAction<number>>;
  }
>(({ pageNum, totalPages, helperText, setPageNum }, ref) => {
  return (
    <div
      id='device-model-pagination'
      css={css`
        max-width: ${DEVICE_LAYOUT_WIDTH};
        width: 100%;
        margin: var(--fabric-space-gap-lg) auto 0;
        display: flex;
        flex-direction: column;
        align-items: center;
      `}
    >
      <Pagination
        pageByPageSelector
        ref={ref}
        page={pageNum}
        total={totalPages ?? 1}
        handleChange={(val: number): void => {
          setPageNum(val);
        }}
      />
      {helperText && (
        <Text textAlign='center' color='subdued' size='medium'>
          {helperText}
        </Text>
      )}
    </div>
  );
});

LineKeyPagination.displayName = 'LineKeyPagination';
